import { render, staticRenderFns } from "./dataAuthorDialog.vue?vue&type=template&id=0c0962c6&scoped=true&"
import script from "./dataAuthorDialog.vue?vue&type=script&lang=js&"
export * from "./dataAuthorDialog.vue?vue&type=script&lang=js&"
import style0 from "./dataAuthorDialog.vue?vue&type=style&index=0&id=0c0962c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0962c6",
  null
  
)

export default component.exports